// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import vuetify from '@/plugins/vuetify'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import myaxios from '@/assets/js/http.js'
import myaxiospay from '@/assets/js/httppay.js'
import 'babel-polyfill';
// import dataV from '@jiaminghi/data-view'
import qwaxios from '@/assets/js/qw-http.js'
import ERP from "./assets/lib/ERP";
import store from "./store"
import moment from 'moment'
// import Page from "./assets/lib/Page";
import VueAMap from "vue-amap";
import _ from 'lodash';

import Oss from '@/common/Oss.js';

//引入公共样式
import './assets/css/app.scss';

// import VForm from 'vform-builds'  //引入VForm库
import 'element-ui/lib/theme-chalk/index.css'  //引入element-ui样式
// import 'vform-builds/dist/VFormDesigner.css'  //引入VForm样式


import vform from '../lib/vform/VFormDesigner.umd.js'
import '../lib/vform/VFormDesigner.css'

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);


import MVFormDesigner from '../lib/m-lib/MVFormDesigner.umd.js'
import '../lib/m-lib/MVFormDesigner.css'
import Logger from "./common/logger/Logger";
import LogController from "./common/logger/LogController";

//Vue.config.productionTip = false


// Vue.use(dataV)
Vue.use(myaxios);
Vue.use(myaxiospay);
Vue.use(iView)
Vue.use(qwaxios);
Vue.use(ElementUI,{ size: 'small', zIndex: 3000 });
Vue.use(VueAMap);
Vue.use(Oss);
Vue.prototype._ = _;
Vue.config.productionTip = false;

Vue.use(MVFormDesigner)
Vue.use(vform)

Vue.filter('dateFormat', (str, partten = "YYYY-MM-DD HH:mm:ss") => {
  return moment(str).format(partten);
})

VueAMap.initAMapApiLoader({
  key: '',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', "AMap.Geocoder", "AMap.Geolocation","AMap.AMapUI"],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});

//挂载全局ERP总控
window.ERP=ERP;
ERP.initAPP();
ERP.vuetifyPage(router);

Logger.push()
LogController.onPage(router)

// Page.initPage()

//挂载ERP在进入Vue上
Vue.prototype.ERP=ERP
Vue.prototype.isPermission=ERP.isPermission

//全局参数配置
ERP.setStore("__TABLE_HEIGHT__",window.innerHeight-400);//表格高度控制
window.onresize=function () {
  ERP.setStore("__TABLE_HEIGHT__",window.innerHeight-400);//表格高度控制
}

window.__MENU_LIST__=[];

/* eslint-disable no-new */
//挂载全局__ERP__
window.__ERP__=new Vue({
  el: '#app',
  router,
  vuetify,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js